import { Block } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { BLOCK_HINT, type BlockHintData, type BlockHintStyle } from '../types';

/**
 * Create a hint block.
 */
export function createHint(props: { style?: BlockHintStyle; nodes?: Block[] } = {}): Block {
    const style = props.style || 'info';
    const nodes = props.nodes || [createParagraph()];
    const data: BlockHintData = {
        style,
    };

    return Block.create({
        type: BLOCK_HINT,
        data,
        nodes,
    });
}
